import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from './BaseComponent';
import Button from './Button';
import Style from './ToolTip.cssmodule.less';

class ToolTip extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            isForMeStyle: Style.hiddenButton,
        };

        this._isForMeTime = 10 * 1000;
        //for development mode
        // this._isForMeTime = 1;
        this._isForMeTimer = null;
    }

    componentDidMount() {
        const { isForMe = false } = this.props;
        if (isForMe) {
            if (this._isForMeTimer) clearTimeout(this._isForMeTimer);
            this._isForMeTimer = setTimeout(() => {
                this.setState({
                    isForMeStyle: undefined,
                });
                this._isForMeTimer = null;
            }, this._isForMeTime);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { isForMe = false } = this.props;
        if (isForMe && this.props.guideIndex !== nextProps.guideIndex) {
            this.setState({
                isForMeStyle: Style.hiddenButton,
            });
        }
    }

    componentDidUpdate() {
        const { isForMe = false } = this.props;
        const { isForMeStyle } = this.state;
        if (isForMe && isForMeStyle) {
            if (this._isForMeTimer) clearTimeout(this._isForMeTimer);
            this._isForMeTimer = setTimeout(() => {
                this.setState({
                    isForMeStyle: undefined,
                });
                this._isForMeTimer = null;
            }, this._isForMeTime);
        }
    }

    getTitle() {
        const { title, titleIndex = 0 } = this.props.content;
        if (!title) return;

        const splited = title.split('$$');

        return splited[titleIndex] || splited[0];
    }

    getContent() {
        const { content, contentIndex = 0 } = this.props.content;
        if (!content) return;

        const splited = content.split('$$');
        const text = splited[contentIndex] || splited[0];
        return (
            <div
                className={Style.content}
                dangerouslySetInnerHTML={{
                    __html: text,
                }}
            />
        );
    }

    render() {
        const { isShowMe = false, isForMe = false, isPrev = true } = this.props;
        return (
            <div className={Style.toolTip}>
                <div className={Style.title}>{this.getTitle()}</div>
                {this.getContent()}
                {this.props.content.block && (
                    <div
                        className={Style.block}
                        ref={(dom) => {
                            if (!this.blockRenderView) {
                                const wrapper = Entry.createElement('div');
                                $(dom).append(wrapper);
                                this.blockRenderView = new Entry.RenderView(
                                    wrapper,
                                    'LEFT_MOST'
                                );
                            }

                            let code = [];
                            if (this.props.content.block) {
                                code = JSON.parse(this.props.content.block);
                            }

                            this.blockRenderView.changeCode(
                                new Entry.Code(code),
                                true
                            );
                        }}
                    />
                )}
                <div className={Style.buttonArea}>
                    {isPrev && (
                        <Button
                            className={Style.prevButton}
                            onClick={() => {
                                this.props.emitter.emit('click', 'prev');
                            }}
                            onMouseDown={() => {
                                this.props.emitter.emit('mousedown', 'prev');
                            }}
                        >
                            <div className={Style.text}>
                                {`${this.getLang('Buttons.previous')}`}
                            </div>
                        </Button>
                    )}
                    <div>
                        {isShowMe && (
                            <Button
                                className={Style.clickButton}
                                onClick={() => {
                                    this.props.emitter.emit('click', 'show_me');
                                }}
                                onMouseDown={() => {
                                    this.props.emitter.emit(
                                        'mousedown',
                                        'show_me'
                                    );
                                }}
                            >
                                <div className={Style.text}>
                                    {`${this.getLang('Buttons.show_me')}`}
                                </div>
                            </Button>
                        )}
                        {isForMe && (
                            <Button
                                className={`${Style.clickButton} ${
                                    this.state.isForMeStyle
                                }`}
                                onClick={() => {
                                    this.props.emitter.emit('click', 'for_me');
                                }}
                                onMouseDown={() => {
                                    this.props.emitter.emit(
                                        'mousedown',
                                        'for_me'
                                    );
                                }}
                            >
                                <div className={Style.text}>
                                    {`${this.getLang(
                                        'Buttons.do_this_for_me'
                                    )}`}
                                </div>
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

ToolTip.displayName = 'ToolTip';
ToolTip.propTypes = {
    content: PropTypes.object,
};
ToolTip.defaultProps = {
    content: {},
};

export default ToolTip;



// WEBPACK FOOTER //
// ./components/CommonSet/ToolTip.js